export const NAME = 'STRIPE';

export const getSetupIntent = (store) =>
  store[NAME].subscription.setupIntent || {};
